import {
  // CLEAR_EVENTV2,
  CREATE_EVENT,
  CREATE_PIECE, // working
  CREATE_SESSION,
  CREATE_STUDENT, // working
  DELETE_PIECE, // working
  DELETE_SESSION,
  DELETE_SESSION_AND_EVENTS,
  DELETE_STUDENT, // working
  EVENT_FETCHING,
  FETCH_EVENTS_BY_SESSIONID,
  FETCH_PIECES, // working
  FETCH_SESSIONS, // working
  GET_STUDENTS, // working
  GET_STUDENT_PERFORMANCE, // working
  GET_STUDENT_TASK_STATUS, // working
  UPDATE_PIECE_STATUS, // working
  UPDATE_RATING_AND_MESSAGE,
  UPDATE_SESSION, // api working, butt need to allow 0 rating to be accepted
} from "../../constants/apiUrls";
import { fetchData } from "../../shared/fetchData";
// import { fetchDataPromiseWrapper } from "../../shared/promiseWrapper";
import actionTypes from "./actionTypes";
import Locale from "../../locales";
import { piecesStatuses } from "../../constants/piecesStatuses";

export const teacherRequestStart = () => {
  return {
    type: actionTypes.TEACHER_REQUEST_START,
  };
};

export const teacherRequestSuccess = (message) => {
  return {
    type: actionTypes.TEACHER_REQUEST_SUCCESS,
    data: message,
  };
};

export const teacherRequestFail = (errMessage) => {
  return {
    type: actionTypes.TEACHER_REQUEST_FAIL,
    data: errMessage,
  };
};

export const clearTeacherError = () => {
  return {
    type: actionTypes.CLEAR_TEACHER_ERROR,
  };
};

export const clearTeacherSuccess = () => {
  return {
    type: actionTypes.CLEAR_TEACHER_SUCCESS,
  };
};

export const onTeacherScreenNavigation = () => {
  return {
    type: actionTypes.ON_TEACHER_SCREEN_NAVIGATION,
  };
};

export const clearTeacherState = () => {
  return {
    type: actionTypes.CLEAR_TEACHER_REDUCER_STATE,
  };
};

export const addStudent = (student, currentUser) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      CREATE_STUDENT,
      {
        studentId: student.emailId,
        studentName: student.name,
        teacherId: currentUser,
      },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("student_added")));
        dispatch({
          type: actionTypes.ADD_STUDENT,
          data: {
            studentId: student.emailId,
            studentName: student.name,
            teacherId: currentUser,
            rating: 0,
            studentMessage: "You are doing Great!!! ",
          },
        });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message));
      },
    );
  };
};

export const deleteStudent = (emailId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      DELETE_STUDENT,
      { studentId: emailId },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("student_removed")));
        dispatch({ type: actionTypes.DELETE_STUDENT, data: emailId });
      },
      (err) => {
        dispatch(teacherRequestFail(err.message));
      },
    );
  };
};

export const updateStudent = (emailId, newEmailId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_STUDENT,
      emailId,
      newEmailId,
    });
  };
};

export const getStudents = (emailId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      GET_STUDENTS,
      { teacherId: emailId },
      (res) => {
        dispatch(teacherRequestSuccess(Locale.t("students_loaded")));
        dispatch({ type: actionTypes.GET_STUDENTS, data: res.students });
      },
      (err) => {
        dispatch(teacherRequestFail(err.message));
      },
    );
  };
};

export const getTasks = (studentId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    let data = [];
    fetchData(
      "POST",
      EVENT_FETCHING,
      { studentId },
      (res) => {
        data = res.allStudentEvents;
        dispatch(teacherRequestSuccess(Locale.t("tasks_loaded")));
        dispatch({ type: actionTypes.GET_TASKS, data });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message));
        // this is because the api throws error when the user selected has no current tasks,make tasks empty
        dispatch({ type: actionTypes.GET_TASKS, data });
      },
    );
  };
};

export const fetchSessions = (studentId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      FETCH_SESSIONS,
      { studentId },
      (res) => {
        dispatch(teacherRequestSuccess(Locale.t("done_sucessfully")));
        dispatch({
          type: actionTypes.FETCH_SESSION,
          data: res.sessions,
        });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

// export const deleteEvent = (eventId, studentId) => {
//   return (dispatch) => {
//     dispatch(teacherRequestStart());
//     fetchData(
//       "POST",
//       CLEAR_EVENTV2,
//       { eventId, studentId },
//       () => {
//         dispatch(teacherRequestSuccess(Locale.t("task_removed")));
//         dispatch({ type: actionTypes.REMOVE_TASK, data: eventId });
//       },
//       (err) => {
//         dispatch(teacherRequestFail(err.message));
//       },
//     );
//   };
// };

export const createTask = (formData) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      CREATE_EVENT,
      { ...formData },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("task_created")));
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message));
      },
    );
  };
};

export const getStudentTaskStatus = (data) => {
  const payload = {
    studentId: data.studentId,
    fromDateTime: data.queryStartDateTimeUTC,
    toDateTime: data.queryEndDateTimeUTC,
  };
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      GET_STUDENT_TASK_STATUS,
      { ...payload },
      (res) => {
        dispatch({
          type: actionTypes.GET_STUDENT_TASK_STATUS,
          data: res.eventStatus,
        });
        dispatch(teacherRequestSuccess(Locale.t("student_report_received")));
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const getStudentPerformance = (data) => {
  const { studentId, queryStartDateTimeUTC, queryEndDateTimeUTC } = data;
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      GET_STUDENT_PERFORMANCE,
      { studentId, queryStartDateTimeUTC, queryEndDateTimeUTC },
      (res) => {
        dispatch(teacherRequestSuccess(Locale.t("student_report_received")));
        dispatch({
          type: actionTypes.GET_STUDENT_PERFORMANCE,
          data: res.studentPerformanceData,
        });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const fetchPieces = (studentId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      FETCH_PIECES,
      { studentId },
      (res) => {
        dispatch(teacherRequestSuccess(Locale.t("pieces_loaded")));
        dispatch({ type: actionTypes.FETCH_PIECES, data: res.pieces });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const createPiece = (formData) => {
  const { studentId } = formData;
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      CREATE_PIECE,
      { ...formData },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("piece_created")));
        dispatch(fetchPieces(studentId));
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const updatePieceStatus = (data) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      UPDATE_PIECE_STATUS,
      { ...data },
      () => {
        let finalPayload = {};
        const newStatus = data.newPieceStatus;
        const previousStatus = data.previousPieceStatus;
        const currentDateTime = data.currentDateTimeISO;

        if (newStatus === piecesStatuses[1]) {
          finalPayload = {
            ...data,
            startDateTimeISO: currentDateTime,
          };
        } else if (newStatus === piecesStatuses[2]) {
          finalPayload = {
            ...data,
            endDateTimeISO: currentDateTime,
          };
        } else if (previousStatus === piecesStatuses[2]) {
          if (newStatus === piecesStatuses[1]) {
            finalPayload = {
              ...data,
              startDateTimeISO: currentDateTime,
            };
          } else {
            finalPayload = { ...data };
          }
        } else {
          finalPayload = { ...data };
        }

        dispatch(teacherRequestSuccess(Locale.t("piece_updated")));
        dispatch(fetchPieces(data.studentId));
        dispatch({ type: actionTypes.UPDATE_PIECE_STATUS, data: finalPayload });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};
export const updatePieceStartDate = (data) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      UPDATE_PIECE_STATUS,
      { ...data },
      () => {
        let finalPayload = {};
        const updatedStartDate = data.updatedStartDateTimeUTC;

        finalPayload = {
          ...data,
          updatedStartDateTimeISO: updatedStartDate,
        };

        dispatch(teacherRequestSuccess(Locale.t("piece_start_date_updated")));
        dispatch(fetchPieces(data.studentId));
        dispatch({ type: actionTypes.UPDATE_PIECE_STATUS, data: finalPayload });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const deletePiece = (pieceId, studentId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      DELETE_PIECE,
      { pieceId, studentId },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("piece_removed")));
        dispatch({ type: actionTypes.DELETE_PIECE, data: pieceId });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const changeRating = (emailId, rating) => {
  return {
    type: actionTypes.UPDATE_RATING,
    data: { studentId: emailId, rating },
  };
};

export const changeStudentMessage = (emailId, studentMessage) => {
  return {
    type: actionTypes.CHANGE_STUDENT_MESSAGE,
    data: { studentId: emailId, studentMessage },
  };
};

export const updateRating = (emailId, rating, studentMessage) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      UPDATE_RATING_AND_MESSAGE,
      { studentId: emailId, rating, studentMessage },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("saved_successfully")));
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const createSession = (data) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      CREATE_SESSION,
      { ...data },
      (res) => {
        const newSession = res.session;
        dispatch(teacherRequestSuccess(Locale.t("session_created")));
        dispatch({ type: actionTypes.CREATE_SESSION, data: newSession });
      },
      (err) => {
        dispatch(teacherRequestFail(err || err.message));
      },
    );
  };
};

export const removeSession = (data) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      DELETE_SESSION,
      { ...data },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("session_removed")));
        dispatch({
          type: actionTypes.REMOVE_SESSION,
          data,
        });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const selectStudent = (emailId) => {
  return { type: actionTypes.SELECT_STUDENT, data: emailId };
};

export const fetchSummary = (data) => {
  const { studentId } = data;
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      GET_STUDENT_PERFORMANCE,
      { ...data },
      (res) => {
        dispatch({
          type: actionTypes.GET_STUDENT_PERFORMANCE,
          data: res.studentPerformanceData,
        });
        dispatch(teacherRequestSuccess(Locale.t("performance_received")));
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
    dispatch(fetchPieces(studentId));
    fetchData(
      "POST",
      FETCH_SESSIONS,
      { studentId },
      (res) => {
        dispatch(teacherRequestSuccess(Locale.t("sessions_fetched")));
        dispatch({
          type: actionTypes.FETCH_SESSION,
          data: res.sessions,
        });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const createSessionV2 = (data) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      CREATE_SESSION,
      { ...data },
      () => {
        dispatch(teacherRequestSuccess(Locale.t("session_saved")));
      },
      (err) => {
        dispatch(teacherRequestFail(err || err.message));
      },
    );
  };
};

export const fetchSessionsV2 = (studentId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      FETCH_SESSIONS,
      { studentId },
      (res) => {
        dispatch(teacherRequestSuccess(Locale.t("done_sucessfully")));
        dispatch({
          type: actionTypes.FETCH_SESSION,
          data: res.sessions,
        });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const fetchEventsBySessionId = (sessionId) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      FETCH_EVENTS_BY_SESSIONID,
      { sessionId },
      (res) => {
        dispatch(teacherRequestSuccess(Locale.t("session_fetched")));
        dispatch({
          type: actionTypes.UPDATING_SESSION,
          data: res,
        });
      },
      (err) => {
        dispatch(teacherRequestFail(err.response.data.message || err.message));
      },
    );
  };
};

export const updateSession = (sessionId, studentId, formData) => {
  return (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      UPDATE_SESSION,
      { ...formData },
      () => {
        dispatch(fetchSessionsV2(studentId));
      },
      (err) => {
        dispatch(teacherRequestFail(err || err.message));
      },
    );
  };
};

export const deleteSession =
  ({ sessionId, studentId }) =>
  (dispatch) => {
    dispatch(teacherRequestStart());
    fetchData(
      "POST",
      DELETE_SESSION_AND_EVENTS,
      { sessionId, studentId },
      () => {
        dispatch(fetchSessionsV2(studentId));
      },
      (err) => {
        dispatch(teacherRequestFail(err || err.message));
      },
    );
  };

export const showStudentReport = (studentID, name) => ({
  type: actionTypes.SET_CURRENT_STUDENT_REPORT,
  data: studentID,
  name,
});
